import { render, staticRenderFns } from "./AddConceptModal.vue?vue&type=template&id=d90508dc&scoped=true&"
import script from "./AddConceptModal.vue?vue&type=script&lang=js&"
export * from "./AddConceptModal.vue?vue&type=script&lang=js&"
import style0 from "./AddConceptModal.vue?vue&type=style&index=0&id=d90508dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d90508dc",
  null
  
)

export default component.exports